export default class CustomError extends Error {
    constructor(errorCode, ...params) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, CustomError);
        }

        this.name = 'CustomError';
        // Custom debugging information
        this.errorCode = errorCode;
        // this.errorMessage = errorMessage;
        this.date = new Date();
    }
}